import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Card, CardHeader, Container, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, MenuItem, Switch, TextField, Tooltip, Typography, styled } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { toast } from 'react-toastify';
import logo from '../Assests/billLogo.png';

const toNumber = (value) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

const getCalculatedSellingPrice = (costPrice, profitMargin) => {
    const cost = toNumber(costPrice);
    const margin = toNumber(profitMargin);
    return Number((cost + (cost * margin) / 100).toFixed(2));
};


export default function ItemUpdateDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID, isUpdateFromItem, items = [] }) {
    const inputRef = useRef(null);
    const [itemData, setItemData] = useState({
        itemName: "",
        itemCategoryID: 0,
        itemType: 0,
        itemRemark: "",
        status: true,
        sellingPrice: 0.0,
        costPrice: 0.0,
        discountedPrice: "",
        defBarcode: "",
        isFavourite: false
    })
    const [categoryList, setCategoryList] = useState([]);
    const [img, setImg] = useState(null);
    const [previewImg, setPreviewImg] = useState(null);
    const [isUpdate, setIsUpdate] = useState(true);
    const [isImageUpload, setIsImageUpload] = useState(false);

    const selectedCategory = categoryList.find(
        (row) => String(row.CategoryID) === String(itemData.itemCategoryID)
    );
    const selectedCategoryProfitMargin = toNumber(selectedCategory?.profitMargin);
    const selectedCategoryName = (selectedCategory?.CategoryName || '').toString().trim().toLowerCase();
    const isOilsCategory = selectedCategoryName === 'oil' || selectedCategoryName === 'oils';

    useEffect(() => {
        GetAllActiveCategoryDetails();
    }, [])

    useEffect(() => {
        const nextSellingPrice = getCalculatedSellingPrice(itemData.costPrice, selectedCategoryProfitMargin);

        setItemData((prev) => {
            if (toNumber(prev.sellingPrice) === nextSellingPrice) {
                return prev;
            }

            return {
                ...prev,
                sellingPrice: nextSellingPrice,
            };
        });
    }, [itemData.costPrice, selectedCategoryProfitMargin]);

    useEffect(() => {
        if (!dialogOpen || !updateID) return;

        const selectedItem = (items || []).find(
            (row) => String(row?.ItemID ?? row?.itemID ?? row?.id ?? '') === String(updateID)
        );
        if (!selectedItem) return;

        const discountedPrice =
            selectedItem.discountedPrice ??
            selectedItem.DiscountedPrice ??
            selectedItem.discountPrice ??
            selectedItem.DiscountPrice ??
            "";

        setItemData({
            itemName: selectedItem.ItemName ?? selectedItem.itemName ?? "",
            itemCategoryID: selectedItem.ItemCategoryID ?? selectedItem.itemCategoryID ?? 0,
            itemType: selectedItem.ItemTypeID ?? selectedItem.itemType ?? 0,
            itemRemark: selectedItem.ItemRemark ?? selectedItem.itemRemark ?? "",
            status: (selectedItem.IsActive ?? selectedItem.isActive ?? 1) == 1,
            sellingPrice: selectedItem.sellingPrice ?? selectedItem.SellingPrice ?? 0.0,
            costPrice: selectedItem.costPrice ?? selectedItem.CostPrice ?? 0.0,
            discountedPrice,
            defBarcode: selectedItem.defbarcode ?? selectedItem.defBarcode ?? "",
            isFavourite: (selectedItem.isfavourite ?? selectedItem.isFavourite ?? 0) == 1,
        });

        setPreviewImg(selectedItem.ItemImage ?? selectedItem.itemImage ?? null);
        setIsUpdate(true);
    }, [dialogOpen, updateID, items])

    function handleClose() {
        setIsUpdate(false);
        setDialogOpen(false);
        ClearData();
    }

    function handleChange(e) {
        const { name, value } = e.target;

        if (name === "sellingPrice") {
            return;
        }

        if (name === "costPrice" || name === "discountedPrice") {
            if (value === "" || /^[0-9]*\.?[0-9]{0,2}$/.test(value)) {
                setItemData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
            return;
        }

        setItemData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    function GetAllActiveCategoryDetails() {
        axios.get('https://serveravotasautofleet.ccsoftwares.com/Category/getallactivecategory').then((res) => {
            if (res.data.length > 0) {
                setCategoryList(res.data);
            }
        })
    }

    function ClearData() {
        setItemData({
            ...itemData,
            itemName: "",
            itemCategoryID: 0,
            itemType: 0,
            itemRemark: "",
            sellingPrice: 0.0,
            costPrice: 0.0,
            discountedPrice: "",
            defBarcode: "",
            isFavourite: false,
            status: true
        })
        removeImage();
        setIsImageUpload();
    }

    const uploadImage = (e) => {
        setImg(e.target.files[0]);
        setPreviewImg(URL.createObjectURL(e.target.files[0]));
        setIsImageUpload(true);
    }

    function removeImage() {
        setImg(null);
        setPreviewImg(null);
        if (inputRef.current) {
            inputRef.current.value = null; // Reset the input value
        }
    }

    function handleStatusChange() {
        setItemData({
            ...itemData,
            status: !itemData.status
        })
    }

    function handleFavouriteChange() {
        setItemData({
            ...itemData,
            isFavourite: !itemData.isFavourite
        })
    }

    function UploadItem() {
        //console.log("itemData:> ", itemData)
        if (isUpdate) {
            const formData = new FormData();
            formData.append("updateID", updateID)
            formData.append("itemName", itemData.itemName.trim())
            formData.append("itemCategoryID", itemData.itemCategoryID)
            formData.append("itemRemark", itemData.itemRemark.trim())
            formData.append("status", itemData.status ? 1 : 0)
            formData.append("sellingPrice", itemData.sellingPrice)
            formData.append("costPrice", itemData.costPrice)
            formData.append("discountedPrice", itemData.discountedPrice ? itemData.discountedPrice : "")
            formData.append("isFavourite", itemData.isFavourite ? 1 : 0)
            formData.append("defBarcode", itemData.defBarcode ? itemData.defBarcode.trim() : "")
            formData.append("previewImg", previewImg)
            formData.append("file", previewImg ? img : null)

            axios.put('https://serveravotasautofleet.ccsoftwares.com/Item/updateItem', formData).then((res) => {
                if (res.data.affectedRows > 0) {
                    handleClose();
                    setIsUpdate(false);
                    setUpdateID(0);
                    toast.success("Item Updated successfully!")
                }
            })
        } else {
            const formData = new FormData();
            formData.append("itemName", itemData.itemName.trim())
            formData.append("itemCategoryID", itemData.itemCategoryID)
            formData.append("itemRemark", itemData.itemRemark.trim())
            formData.append("status", itemData.status ? 1 : 0)
            formData.append("sellingPrice", itemData.sellingPrice)
            formData.append("costPrice", itemData.costPrice)
            formData.append("discountedPrice", itemData.discountedPrice ? itemData.discountedPrice : "")
            formData.append("isFavourite", itemData.isFavourite ? 1 : 0)
            formData.append("defBarcode", itemData.defBarcode ? itemData.defBarcode.trim() : "")
            formData.append("previewImg", previewImg)
            formData.append("file", previewImg ? img : null)

            //console.log(formData)
            axios.post('https://serveravotasautofleet.ccsoftwares.com/Item/createItem', formData).then((res) => {
                if (res.data > 0) {
                    handleClose();
                    toast.success("Item Added successfully!");
                }
            })
        }
    }

    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={dialogOpen}
            fullWidth={true}         // Ensures the dialog uses the full width of the container
            maxWidth='md'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Update Item
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            itemName: itemData.itemName,
                            itemCategoryID: itemData.itemCategoryID,
                            itemType: itemData.itemType,
                            itemRemark: itemData.itemRemark,
                            sellingPrice: itemData.sellingPrice,
                            costPrice: itemData.costPrice,
                            discountedPrice: itemData.discountedPrice,
                            defBarcode: itemData.defBarcode,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                itemName: Yup.string()
                                    .required('Item Name is required')
                                    .test('no-leading-space', 'Item Name cannot start with a space', value => value && value.trim().length > 0),
                                itemCategoryID: Yup.number()
                                    .required('Item Category is required')
                                    .test('valid-selection', 'Please select a valid item category', value => value !== 0),
                                defBarcode: Yup.string()
                                    .max(100, 'Default Barcode can be at most 100 characters.')
                                ,
                                discountedPrice: Yup.number()
                                    .transform((value, originalValue) => (originalValue === '' ? null : value))
                                    .typeError('Discount Price must be a number')
                                    .min(0, 'Discount Price cannot be negative')
                                    .nullable(true)
                            })
                        }

                        onSubmit={() => UploadItem()}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Grid container spacing={2}>
                                        <Grid item md={6} xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.itemName && errors.itemName)}
                                                        helperText={touched.itemName && errors.itemName}
                                                        onBlur={handleBlur}
                                                        label="Item Name *"
                                                        name='itemName'
                                                        value={itemData.itemName}
                                                        id='itemName'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.defBarcode && errors.defBarcode)}
                                                        helperText={touched.defBarcode && errors.defBarcode}
                                                        onBlur={handleBlur}
                                                        label="Default Barcode"
                                                        name='defBarcode'
                                                        value={itemData.defBarcode}
                                                        id='defBarcode'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        error={Boolean(touched.itemCategoryID && errors.itemCategoryID)}
                                                        helperText={touched.itemCategoryID && errors.itemCategoryID}
                                                        onBlur={handleBlur}
                                                        label="Item Category *"
                                                        name='itemCategoryID'
                                                        value={itemData.itemCategoryID}
                                                        id='itemCategoryID'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        <MenuItem key={0} value={0}>Select Item Category</MenuItem>
                                                        {categoryList.map((row) => (
                                                            <MenuItem key={row.CategoryID} value={row.CategoryID}>{row.CategoryID} - {row.CategoryName}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>

                                                {isOilsCategory ? (
                                                    <Grid item md={12} xs={12}>
                                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                            Oils: Enter the selling price and cost price for 1L.
                                                        </Typography>
                                                    </Grid>
                                                ) : null}

                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        helperText={`Auto from cost + ${selectedCategoryProfitMargin.toFixed(2)}% margin`}
                                                        onBlur={handleBlur}
                                                        label={isOilsCategory ? "Selling Price (1L) (Auto)" : "Selling Price (Auto)"}
                                                        name="sellingPrice"
                                                        value={itemData.sellingPrice}
                                                        id="sellingPrice"
                                                        onChange={() => {}}
                                                        inputProps={{
                                                            inputMode: "decimal",
                                                            pattern: "^[0-9]*\\.?[0-9]{0,2}$",
                                                            readOnly: true,
                                                        }}
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                    />

                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.costPrice && errors.costPrice)}
                                                        helperText={touched.costPrice && errors.costPrice}
                                                        onBlur={handleBlur}
                                                        label={isOilsCategory ? "Cost Price (1L) *" : "Cost Price *"}
                                                        name="costPrice"
                                                        value={itemData.costPrice}
                                                        id="costPrice"
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={() => {
                                                            setItemData((prev) => ({
                                                                ...prev,
                                                                costPrice: prev.costPrice === 0.0 ? "" : prev.costPrice,
                                                            }));
                                                        }}
                                                        inputProps={{
                                                            inputMode: "decimal",
                                                            pattern: "^[0-9]*\\.?[0-9]{0,2}$",
                                                        }}
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.discountedPrice && errors.discountedPrice)}
                                                        helperText={touched.discountedPrice && errors.discountedPrice}
                                                        onBlur={handleBlur}
                                                        label="Discount Price"
                                                        name="discountedPrice"
                                                        value={itemData.discountedPrice}
                                                        id="discountedPrice"
                                                        onChange={(e) => handleChange(e)}
                                                        onFocus={() => {
                                                            setItemData((prev) => ({
                                                                ...prev,
                                                                discountedPrice: prev.discountedPrice === 0 ? "" : prev.discountedPrice,
                                                            }));
                                                        }}
                                                        inputProps={{
                                                            inputMode: "decimal",
                                                            pattern: "^[0-9]*\\.?[0-9]{0,2}$",
                                                        }}
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        error={Boolean(touched.itemRemark && errors.itemRemark)}
                                                        helperText={touched.itemRemark && errors.itemRemark}
                                                        onBlur={handleBlur}
                                                        label="Item Remark"
                                                        name='itemRemark'
                                                        value={itemData.itemRemark}
                                                        id='itemRemark'
                                                        onChange={(e) => handleChange(e)}
                                                        variant="outlined"
                                                        size="small"
                                                        type='text'
                                                        multiline
                                                        rows={4}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <Grid container spacing={3}>
                                                <Grid item md={12} xs={12}>
                                                    <input
                                                        ref={inputRef}
                                                        type='file'
                                                        accept='image/*'
                                                        onChange={(e) => uploadImage(e)}
                                                        className='inputImage'
                                                        disabled={previewImg}
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px',
                                                            border: '1px solid #ced4da',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#fff',
                                                            color: '#000000',
                                                            outline: 'none',
                                                            boxShadow: 'none',
                                                            boxSizing: 'border-box',
                                                            height: 'auto'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    {isUpdate ?
                                                        <>
                                                            {isImageUpload ?
                                                                <>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <img
                                                                                src={previewImg}
                                                                                width='180px'
                                                                                height='180px'
                                                                                alt='item'
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={logo}
                                                                                width='200px'
                                                                                height='180px'
                                                                                alt='item'
                                                                            />
                                                                        }
                                                                    </center>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <IconButton>
                                                                                <CancelIcon
                                                                                    sx={{ color: 'red' }}
                                                                                    onClick={removeImage}
                                                                                />
                                                                            </IconButton>
                                                                            : null}
                                                                    </center>
                                                                </>
                                                                :
                                                                <>
                                                                    <center>
                                                                        {previewImg && isUpdate ?
                                                                            <img
                                                                                src={`https://serveravotasautofleet.ccsoftwares.com/Assets/Items/${previewImg}`}
                                                                                width='180px'
                                                                                height='180px'
                                                                            />
                                                                            :
                                                                            <img
                                                                                src={logo}
                                                                                width='180px'
                                                                                height='180px'
                                                                            />
                                                                        }
                                                                    </center>
                                                                    <center>
                                                                        {previewImg ?
                                                                            <IconButton>
                                                                                <CancelIcon
                                                                                    sx={{ color: 'red' }}
                                                                                    onClick={removeImage}
                                                                                />
                                                                            </IconButton>
                                                                            : null}
                                                                    </center>
                                                                </>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            <center>
                                                                {previewImg && !isUpdate ?
                                                                    <img
                                                                        src={previewImg}
                                                                        width='180px'
                                                                        height='180px'
                                                                    />
                                                                    :
                                                                    <img
                                                                        src={logo}
                                                                        width='180px'
                                                                        height='180px'
                                                                    />
                                                                }
                                                            </center>
                                                            <center>
                                                                {previewImg ?
                                                                    <IconButton>
                                                                        <CancelIcon
                                                                            sx={{ color: 'red' }}
                                                                            onClick={removeImage}
                                                                        />
                                                                    </IconButton>
                                                                    : null}
                                                            </center>
                                                        </>
                                                    }

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item md={6} xs={12} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                            <Typography>Active</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={itemData.status}
                                                onChange={handleStatusChange}
                                                status="isActive"
                                                label="Status"
                                            />

                                        </Grid>
                                        <Grid item md={6} xs={12} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                            <Typography>Is Favourite</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={itemData.isFavourite}
                                                onChange={handleFavouriteChange}
                                                status="isActive"
                                                label="Status"
                                            />

                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            {isUpdate ? null
                                                :
                                                <Button
                                                    variant="contained"
                                                    sx={{ width: '30%' }}
                                                    onClick={ClearData}
                                                >
                                                    clear
                                                </Button>
                                            }

                                            &nbsp; &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '30%' }}
                                            >
                                                {isUpdate ? 'Update' : 'Submit'}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </DialogContent>
        </Dialog >
    )
}
